<template>
    <div id="app">
        <AppLoader/>
    </div>
</template>

<script>
    import Queue from "@/mixins/Queue";
    import { uuid } from 'vue-uuid';

    export default {
        mixins: [Queue],
        name: 'App',
        head: {
            title: function() {
                return {
                    inner: process.env.VUE_APP_URL_TITLE,
                }
            },
            meta: function() {
                return [
                    {name: 'description', content: process.env.VUE_APP_URL_DESCRIPTION, id: 'desc'}
                ]                
            },
            link: function() {
                return [
                    { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/fontawesome-free/css/all.min.css') },
                    { rel: 'icon', href: process.env.VUE_APP_URL_FAVICON , sizes: '16x16', type: 'image/png' }, 
                ]
            }
        },
        components: {
            AppLoader: () => import(/* webpackPrefetch: true */ '@/AppLoader'),
        },
        mounted() {
            if(this.$route.query.api_token) {
                localStorage.removeItem('token');
                localStorage.setItem('token', this.$route.query.api_token);
            }

            if(! localStorage.getItem('uuid')) {
                localStorage.setItem('uuid', uuid.v4());
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .v--modal-overlay {
        z-index: 9999 !important;
    }
</style>
